<div class="deletion-page">
  <div class="deletion-card">

    <div class="deletion-loading" *ngIf="loading && !scheduledDate">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '40px', height: '40px' }"></p-progressSpinner>
    </div>

    <ng-container *ngIf="!loading || scheduledDate">
      <h1 *ngIf="scheduledDate; else noDate">{{ 'user.accountDeletion.pendingTitle' | transloco: { date: scheduledDate } }}</h1>
      <!-- Sem data (flag sem data e GET falhou): título sem inventar um prazo. -->
      <ng-template #noDate><h1>{{ 'user.accountDeletion.pendingTitleNoDate' | transloco }}</h1></ng-template>

      <p class="deletion-lead">{{ 'user.accountDeletion.pendingGiveUpHint' | transloco }}</p>

      <!-- O plano foi cancelado no pedido e não volta: quem desiste volta no Free. -->
      <p class="deletion-notice">{{ 'user.accountDeletion.pendingPlanNotice' | transloco }}</p>

      <div class="deletion-actions">
        <p-button
          severity="danger"
          [raised]="true"
          [loading]="cancelling"
          [disabled]="loading"
          label="{{ 'user.accountDeletion.giveUp' | transloco }}"
          (onClick)="giveUp()">
        </p-button>
        <p-button
          severity="secondary"
          [raised]="true"
          label="{{ 'user.accountDeletion.logout' | transloco }}"
          (onClick)="logout()">
        </p-button>
      </div>

      <!-- Exportar os dados continua liberado na carência (a API só barra o resto). -->
      <h2 class="deletion-section">{{ 'user.dataExport.pendingTitle' | transloco }}</h2>
      <app-data-export></app-data-export>
    </ng-container>

  </div>
</div>
